import { lazy, Suspense, useEffect, useState } from "react";

/// Components
import Index from "./jsx";
import { connect, useDispatch } from "react-redux";
import {
  Route,
  Routes,
  useLocation,
  useNavigate,
  useParams,
  Navigate,
} from "react-router-dom";
// action
import { checkAutoLogin } from "./services/AuthService";
import { isAuthenticated } from "./store/selectors/AuthSelectors";
/// Style
// import "./other/bootstrap-select/dist/css/bootstrap-select.min.css";
import "./css/style.css";
import ResetPassword from "./jsx/pages/ResetPassword";
import InviteAccept from "./jsx/pages/InviteAccept";

const IconList = lazy(() => import("./jsx/pages/Icons"));
const ForgotPassword = lazy(() => import("./jsx/pages/ForgotPassword"));
const SignUp = lazy(() => import("./jsx/pages/Registration"));
const Login = lazy(() => {
  return new Promise((resolve) => {
    setTimeout(() => resolve(import("./jsx/pages/Login")), 500);
  });
});

function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    let location = useLocation();
    let navigate = useNavigate();
    let params = useParams();

    return <Component {...props} router={{ location, navigate, params }} />;
  }

  return ComponentWithRouterProp;
}

function App(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [authChecked, setAuthChecked] = useState(false);
  const REDIRECT_ON_AUTH = ["/", "/login"];
  // Public links
  const PUBLIC = [
    "/login",
    "/forgot-password",
    "/invited",
    "/api/invites/accept",
    "/reset-password",
    "/",
  ];
  const AFTER_LOGIN = "/dashboard";

  const normalizePath = (p) => (p === "/" ? "/" : p.replace(/\/+$/, ""));
  const path = normalizePath(location.pathname);
  const onPublic = PUBLIC.some((p) => path === p || path.startsWith(p + "/"));

  useEffect(() => {
    (async () => {
      const authed = await checkAutoLogin(dispatch);
      setAuthChecked(true);

      if (!authed && !onPublic) {
        navigate("/login", {
          replace: true,
          state: { from: { pathname: path, search: location.search } },
        });
        return;
      }

      if (authed && REDIRECT_ON_AUTH.includes(path)) {
        const fromPath = location.state?.from?.pathname || AFTER_LOGIN;
        const fromSearch = location.state?.from?.search || "";
        navigate(fromPath + fromSearch, { replace: true });
      }
    })();
  }, [dispatch, navigate, path, location.search]);

  let routeblog = (
    <Routes>
      <Route path="/" element={<Navigate to="/login" replace />} />
      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/invited" element={<SignUp />} />
      <Route path="/icon-list" element={<IconList />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/api/invites/accept" element={<InviteAccept />} />
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );

  if (!authChecked) {
    return (
      <div id="preloader">
        +{" "}
        <div className="sk-three-bounce">
          <div className="sk-child sk-bounce1"></div>
          <div className="sk-child sk-bounce2"></div>
          <div className="sk-child sk-bounce3"></div>
        </div>
        +{" "}
      </div>
    );
  }
  if (props.isAuthenticated) {
    return (
      <>
        <Suspense
          fallback={
            <div id="preloader">
              <div className="sk-three-bounce">
                <div className="sk-child sk-bounce1"></div>
                <div className="sk-child sk-bounce2"></div>
                <div className="sk-child sk-bounce3"></div>
              </div>
            </div>
          }
        >
          <Index />
        </Suspense>
      </>
    );
  } else {
    return (
      <div className="vh-100">
        <Suspense
          fallback={
            <div id="preloader">
              <div className="sk-three-bounce">
                <div className="sk-child sk-bounce1"></div>
                <div className="sk-child sk-bounce2"></div>
                <div className="sk-child sk-bounce3"></div>
              </div>
            </div>
          }
        >
          {routeblog}
        </Suspense>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isAuthenticated: isAuthenticated(state),
  };
};

export default withRouter(connect(mapStateToProps)(App));
